define('SageDotCom/DataLayer/Events/bodySelect',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function BodySelectEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "body_selection"; // overwrite name
    }

    BodySelectEvent.prototype = Object.create(EventBase.prototype);

    BodySelectEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label, name, category, level2, level1, elementTag = "a") {
        var eventName = name || this.getName();
        var eventCategory = category || "component";
        var eventLevel2 = "";
        if (level2 !== "") eventLevel2 = this.getId(scope);
        var eventData = {
            'event_name': eventName,
            'event_non-int': "0",
            'event_category': eventCategory,
            'event_action': this.getName()
        }

        if (scope) {
            var lbl = label || $(scope).attr("data-title") || $(scope).text() || $("a:first", scope).text() || $("button:first", scope).text() || "";
            var location = this.getLocation(scope);
            var id = $(scope).attr("id") || $(scope).attr("href") || "";

            var eventLevel1 = (id !== "") ? elementTag + '[href^="#' + id.replace("#", "") + '"]' : "";
            if (level1 === "id") {
                eventLevel1 = id;
            }
            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html
                'event_name_level_1': eventLevel1,
                'event_name_level_2': eventLevel2,
                'event_name_level_3': "",
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new BodySelectEvent();
});
